<div class="modal-header" appCustomAutofocus>
    <h3>Time Worked Notes</h3>
</div>
<div class="modal-body">
    <div>
        <ng-select [searchable]="false"
                   [clearable]="false"
                   [(ngModel)]="selectedNote"
                   name="selectedNote"
                   dropdownPosition="bottom">
            <ng-option *ngFor="let note of notes" [value]="note">{{note.DisplayValue}}</ng-option>
        </ng-select>
    </div>
    <div>
        <label><strong>Note:</strong></label>
        <textarea class="form-control"
                  *ngIf="!isSubmitted"
                  [(ngModel)]="selectedNote.Note">
        </textarea>
        <br *ngIf="isSubmitted" />
        <span *ngIf="isSubmitted">{{selectedNote.Note}}</span>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="updateClicked()" *ngIf="!isSubmitted">Update</button>
    <button type="button" class="btn btn-outline-dark" (click)="cancelClicked()">{{isSubmitted ? 'Close' : 'Cancel'}}</button>
</div>